import * as echarts from 'echarts';
import DummyData from './analyse/DummyData';
import AnalysisApp from './analyse/AnalysisApp';
import AnalysisRenderer from './analyse/AnalysisRenderer';

if (typeof document !== 'undefined') {
    document.documentElement.classList.add('js');
}

window.echarts = echarts;

const dummyData = new DummyData();
const renderer = new AnalysisRenderer();

const chartIds = ['pieAngle', 'beforeAfter', 'g_driver', 'g_planner', 'g_connector', 'g_innovator'];

const analysisApp = new AnalysisApp({
    dataProvider: dummyData,
    echarts,
    chartIds,
    renderer
});

window.addEventListener('DOMContentLoaded', () => {
    console.log('[ShapeFactor] Init started');
    console.log('[ShapeFactor] UserResult (Raw):', window.sfUserResult);
    
    if (window.sfUserResult) {
        console.log('[ShapeFactor] Data keys:', Object.keys(window.sfUserResult));
        if (window.sfUserResult.normal) console.log('[ShapeFactor] Normal data:', window.sfUserResult.normal);
        if (window.sfUserResult.stress) console.log('[ShapeFactor] Stress data:', window.sfUserResult.stress);
    } else {
        // console.warn('[ShapeFactor] No user result found. Using dummy data.');
    }

    console.log('[ShapeFactor] Containers:', {
        pie: document.getElementById('pieAngle'),
        resultsApp: document.getElementById('resultsApp'),
        beforeAfter: document.getElementById('beforeAfter')
    });
    analysisApp.init();
});

// Public API
window.updateDashboard = analysisApp.updateDashboard;

